import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { Card } from '../ui/Card';
const programs = [{
  title: 'Little Dragons',
  age: 'Ages 4-6',
  description: 'Fun, high-energy classes that teach focus, listening skills, and basic coordination.',
  image: 'https://images.unsplash.com/photo-1555597673-b21d5c935865?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Youth Program',
  age: 'Ages 7-12',
  description: 'Building confidence, discipline, and self-defense skills in a structured environment.',
  image: 'https://images.unsplash.com/photo-1518619745898-93e765966dcd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Teen & Adult',
  age: 'Ages 13+',
  description: 'Get fit, learn self-defense, and relieve stress with our comprehensive adult curriculum.',
  image: 'https://images.unsplash.com/photo-1595078475328-1ab05d0a6a0e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}, {
  title: 'Family Classes',
  age: 'All Ages',
  description: 'Train together! A unique opportunity for parents and children to bond through martial arts.',
  image: 'https://images.unsplash.com/photo-1599058945522-28d584b6f0ff?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80'
}];
export function ProgramsOverview() {
  return <section className="py-20 bg-gray-50" data-id="element-51">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-52">
        <div className="flex flex-col md:flex-row justify-between items-end mb-12" data-id="element-53">
          <div className="max-w-2xl" data-id="element-54">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-55">
              Programs for Every Age
            </h2>
            <p className="text-lg text-gray-600" data-id="element-56">
              Whether you're looking for focus for your child or fitness for
              yourself, we have a class that fits your needs.
            </p>
          </div>
          <Link to="/programs" className="hidden md:block" data-id="element-57">
            <Button variant="outline" data-id="element-58">View All Programs</Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-59">
          {programs.map((program, index) => <motion.div key={program.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1,
          duration: 0.5
        }} data-id="element-60">
              <Card className="h-full flex flex-col hover:shadow-lg transition-shadow duration-300" data-id="element-61">
                <div className="h-48 overflow-hidden" data-id="element-62">
                  <img src={program.image} alt={program.title} className="w-full h-full object-cover hover:scale-105 transition-transform duration-500" data-id="element-63" />
                </div>
                <div className="p-6 flex-1 flex flex-col" data-id="element-64">
                  <div className="mb-4" data-id="element-65">
                    <span className="text-xs font-bold text-primary uppercase tracking-wider bg-blue-50 px-2 py-1 rounded" data-id="element-66">
                      {program.age}
                    </span>
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-67">
                    {program.title}
                  </h3>
                  <p className="text-gray-600 text-sm mb-6 flex-1" data-id="element-68">
                    {program.description}
                  </p>
                  <Link to="/programs" className="mt-auto" data-id="element-69">
                    <Button variant="secondary" size="sm" fullWidth data-id="element-70">
                      Learn More
                    </Button>
                  </Link>
                </div>
              </Card>
            </motion.div>)}
        </div>

        <div className="mt-8 text-center md:hidden" data-id="element-71">
          <Link to="/programs" data-id="element-72">
            <Button variant="outline" fullWidth data-id="element-73">
              View All Programs
            </Button>
          </Link>
        </div>
      </div>
    </section>;
}